<template>
  <div>
    <section class="hero is-primary is-medium">
      <div class="hero-body has-text-centered">
        <h1 class="title">
          FeedLetter Wall of Love
        </h1>
        <h2 class="subtitle">
          What Users Say
        </h2>
        <div>
        <p class="starability-result" data-rating="5">
          Rated: 5/5 (99 votes)
        </p>
        &empty; 5/5 (99 votes)
        </div>
      </div>
    </section>

    <WallOfLoveSection />
  </div>
</template>

<script>

import WallOfLoveSection from "@/components/WallOfLoveSection.vue";
export default {
  name: "FeedLetterWallOfLove",
  components: { WallOfLoveSection},
  data: function () {
    return {

    };
  },
  methods: {
    
  },
};
</script>

